import React from 'react';
import { FlowerIcon, MapPinIcon } from 'lucide-react';
import { PageHeader } from '../components/shared/PageHeader';
import { BalloonIcon } from '../components/shared/BalloonIcon';
import { Reveal } from '../components/shared/Reveal';
import { CtaBand } from '../components/shared/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { photos } from '../data/site';
import { useSeo } from '../hooks/useSeo';
export function About() {
  const {
    t,
    lang
  } = useLanguage();
  const a = t.about;
  useSeo({
    ...t.common.seo.about,
    lang
  });
  return <main data-id="element-416" data-mp="3751eaalh1bic">
      <PageHeader eyebrow={a.eyebrow} title={a.title} description={a.intro} data-id="element-417" data-mp="2sa4ztfn2jrwt" />

      <section className="bg-white py-16 sm:py-20" data-id="element-418" data-mp="2sc7nht0r18yd">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-419" data-mp="2x8eu7o0yyohd">
          <Reveal data-id="element-420" data-mp="1gtwput5b5eb4">
            <div className="grid grid-cols-5 gap-4" data-id="element-421" data-mp="1gtepplfiyfxx">
              <img src={photos.quinceOutdoor} alt={a.imageAlt} className="col-span-3 aspect-[3/4] w-full rounded-2xl object-cover" data-id="element-422" data-mp="1luki1i59w16x" />
              <img src={photos.sageWeddingArch} alt={a.imageAlt2} className="col-span-2 mt-12 aspect-[9/16] w-full rounded-2xl object-cover" data-id="element-423" data-mp="1piyt1f9bzadt" />
            </div>
          </Reveal>
          <Reveal data-id="element-424" data-mp="1yilpdmn7dq00">
            <h2 className="font-display text-3xl font-semibold text-ink sm:text-4xl" data-id="element-425" data-mp="1ylhr7m268ytq">{a.story.title}</h2>
            {a.story.paragraphs.map(p => <p key={p} className="mt-5 text-[15px] leading-relaxed text-ink/75 sm:text-base" data-id="element-426" data-mp="28icoy2qmev6y">
                {p}
              </p>)}
          </Reveal>
        </div>
      </section>

      <section className="bg-cream py-16 sm:py-20" data-id="element-427" data-mp="2i6unedbfgq7f">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-428" data-mp="2i9h2qz4k8a07">
          <h2 className="font-display text-3xl font-semibold text-ink sm:text-4xl" data-id="element-429" data-mp="2w8710i348fq5">{a.expertise.title}</h2>
          <div className="mt-10 grid gap-10 md:grid-cols-2" data-id="element-430" data-mp="2r9dl6j0cwcmt">
            {[{
            icon: <FlowerIcon className="h-7 w-7 text-mauve" aria-hidden="true" data-id="element-431" data-mp="1ovfskkmbfryz" />,
            ...a.expertise.flowers
          }, {
            icon: <BalloonIcon className="h-7 w-7 text-mauve" data-id="element-432" data-mp="1sx19ch1z0qeg" />,
            ...a.expertise.balloons
          }].map(item => <Reveal key={item.title} data-id="element-433" data-mp="1xu02aw9werb2">
                <div className="border-t border-mauve/20 pt-6" data-id="element-434" data-mp="22lrkaieznopl">
                  {item.icon}
                  <h3 className="mt-4 font-display text-2xl font-semibold text-ink" data-id="element-435" data-mp="27l4ejo86vy27">{item.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-ink/75" data-id="element-436" data-mp="2cjyy4sdzdqnd">{item.text}</p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </section>

      <section className="bg-white py-16 sm:py-20" data-id="element-437" data-mp="2lkx1r9kibw5f">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-438" data-mp="2lkdkzw6lfdsz">
          <Reveal data-id="element-439" data-mp="m92zg3f1gt8r">
            <div className="h-full rounded-3xl bg-mauve-deep p-8 text-white sm:p-10" data-id="element-440" data-mp="m9m78raz6192">
              <h2 className="font-display text-3xl font-semibold" data-id="element-441" data-mp="r7e9of98x5ri">{a.mission.title}</h2>
              <p className="mt-5 text-lg leading-relaxed text-white/85" data-id="element-442" data-mp="jo50am0qp72g">{a.mission.text}</p>
            </div>
          </Reveal>
          <Reveal data-id="element-443" data-mp="eujzkm7rhyzk">
            <MapPinIcon className="h-7 w-7 text-mauve" aria-hidden="true" data-id="element-444" data-mp="9xjuadiql09i" />
            <h2 className="mt-4 font-display text-3xl font-semibold text-ink" data-id="element-445" data-mp="9vh67z159h7f">{a.area.title}</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-ink/75" data-id="element-446" data-mp="50a58yz9eqm7">{a.area.text}</p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-447" data-mp="12lpija9017e3">
              {a.area.towns.map(town => <li key={town} className="rounded-full bg-petal/70 px-4 py-2 text-sm text-mauve-deep" data-id="element-448" data-mp="xnxoa9kvt96q">
                  {town}
                </li>)}
            </ul>
          </Reveal>
        </div>
      </section>

      <CtaBand data-id="element-449" data-mp="3deago2ymlpxd" />
    </main>;
}